import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

interface ErrorResultProps {
  title?: string;
  subtitle?: string;
  onRetry?: () => void;
}

export function ErrorResult({ title = 'Something went wrong', subtitle, onRetry }: ErrorResultProps) {
  const navigate = useNavigate();

  return (
    <Result
      status="error"
      title={title}
      subTitle={subtitle || 'An unexpected error occurred. Please try again.'}
      extra={[
        onRetry && <Button key="retry" type="primary" onClick={onRetry}>Retry</Button>,
        <Button key="home" onClick={() => navigate('/')}>Back to Dashboard</Button>,
      ].filter(Boolean)}
    />
  );
}
